import React, { useContext } from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { showDateLongFormat, showDateNoTime } from 'utils/NwMoment';
import { ConfigContext } from 'contexts/ConfigContext';
import { thin } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePackage } from 'contexts/PackageContext';
import { useWindowWidth } from '@react-hook/window-size';

const PackageInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media (max-width: 640px) {
        align-items: center;
    }

    .package-info-extra {
        color: ${props => props.theme.TextColor};
        margin-top: .75rem;
        padding-right: ${props => props.$drawerMode ? "1.25rem" : "0"};
        font-size: .85rem;
        line-height: 1.25em;
        text-align: right;
        max-width: 100%;

        img {
            max-width: 100%;
        }

        @media (max-width: 640px) {
            text-align: center;
        }
    }
`;

const PackageInfoContainer = styled.div`
    color: ${props => props.theme.TextColor};
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    padding-right: ${props => props.$drawerMode ? "1.25rem" : "0"};

    @media (max-width: 640px) {
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .ant-avatar {
        margin: 1rem;

        @media (max-width: 640px) {
            margin: .25rem .5rem;
        }
    }

    .texts-wrapper {
        padding-top: .75rem;
        text-align: right;

        @media (max-width: 640px) {
            padding-top: 0;
        }

        h2 {
            font-size: 1rem;
            line-height: 1.5em;
            font-weight: ${props => props.theme.FontWeightBold};
            margin: 0;
            text-transform: uppercase;
            text-align: right;

            @media (max-width: 640px) {
                text-align: center;
            }
        }
        p {
            font-size: .85rem;
            margin: 0;
            line-height: 1.25em;
        }
        .sent-by {
            display: ${props => props.$drawerMode ? "block" : "flex"};
            align-items: center;
            justify-content: flex-end;
            p {
                margin-right: ${props => props.$drawerMode ? "0" : ".25rem"};
            }

            @media (max-width: 640px) {
                justify-content: center;
            }
        }

        .booker-email {
            margin-top: .25rem;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            svg {
                margin-right: .5rem;
            }

            @media (max-width: 640px) {
                margin-top: 0;
                justify-content: center;
            }
        }
        &.no-avatar {
            padding: ${props => props.$drawerMode ? ".5rem 0 0 1rem" : "0"};
        }
    }
`;

const PackageInfo = ({ drawerMode, onClick }) => {

    const { currentPack } = usePackage();
    const { tenantConfig, clientConfig } = useContext(ConfigContext);
    const { CloudFilesContainerUrl } = tenantConfig

    const showExtraInDrawer = (clientConfig && clientConfig.packageInfo && clientConfig.packageInfo.showExtraInDrawer === true);
    const packageInfoExtra = (clientConfig && clientConfig.packageInfo && clientConfig.packageInfo.extra && (!drawerMode || showExtraInDrawer))
        ? clientConfig.packageInfo.extra
        : null;

    const hasAvatar = currentPack ? currentPack.Booker.CoverGuid !== null : false;
    const textsWrapperClass = hasAvatar ? "texts-wrapper" : "texts-wrapper no-avatar";
    const width = useWindowWidth()

    const PackageInfoContainerContent = () => {
        return (
            <>
                {hasAvatar && <Avatar size={width > 640 ? 64 : 48} src={`${CloudFilesContainerUrl}/${currentPack.Booker.CoverGuid}_c.jpg`} />}
                <div className={textsWrapperClass}>
                    <h2>{currentPack.Name}</h2>
                    <div className="sent-by">
                        <p>{`sent by ${currentPack.Booker.Name} ${currentPack.Booker.Surname[0]}.`}, on {width > 640 ? showDateLongFormat(currentPack.DateCreated) : showDateNoTime(currentPack.DateCreated)}</p>
                    </div>
                    <div className="booker-email">
                        <FontAwesomeIcon icon={thin("envelope")} size="xs" />
                        <p>{currentPack.Booker.SenderEmail ? currentPack.Booker.SenderEmail : currentPack.Booker.Email}</p>
                    </div>
                </div>
            </>
        )
    }

    return (
        currentPack
            ?
            <PackageInfoWrapper $drawerMode={drawerMode}>
                <PackageInfoContainer $drawerMode={drawerMode} onClick={onClick}>
                    <PackageInfoContainerContent />
                </PackageInfoContainer>
                {packageInfoExtra &&
                    <div className="package-info-extra" dangerouslySetInnerHTML={{ __html: packageInfoExtra }} />
                }
            </PackageInfoWrapper>
            :
            <div />
    )
};

export default PackageInfo;
